import { render, staticRenderFns } from "./IconRequest.vue?vue&type=template&id=20518ea8"
import script from "./IconRequest.vue?vue&type=script&lang=js"
export * from "./IconRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports